<template>
  <div class="h-screen flex w-full vx-row no-gutter items-center justify-center"  :class="{'bg-img': !isSigaFacil, 'bg-color': isSigaFacil}"  id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4" v-if="!isSigaFacil">
        <vx-card >
            <div slot="no-body" class="full-page-bg-color">
                <div class="vx-row no-gutter justify-center items-center" :style="getBgColor">
                      <div class="vx-col hidden lg:block lg:w-1/2 ">
                        <img :src="getLogoCentral" alt="login" class="mx-auto">
                      </div>

                      <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="px-8 pt-8 login-tabs-container">
                                <div class="vx-card__title mb-4">
                                    <div class="flex items-center" >
                                        <h4 class="mb-4"><feather-icon icon="LogInIcon" class="mr-4" /> {{ $t('Acesso') }}</h4>  
                                        <p class="ml-auto text-xs font-medium"> {{VERSAO}} </p>
                                    </div>
                                    <p>{{ $t('MensagemAcesso') }}</p>
                                    
                                </div>
                                <div class="flex flex-wrap justify-between mb-4">                    
                                      <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                                      <span class="cursor-pointer flex items-center i18n-locale">
                                        <img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
                                        <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>
                                      </span>
                                      <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
                                        <vs-dropdown-item @click="updateLocale('en')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;English</vs-dropdown-item>
                                        <vs-dropdown-item @click="updateLocale('es')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/es.png" alt="es" /> &nbsp;Español</vs-dropdown-item>      
                                        <vs-dropdown-item @click="updateLocale('pt')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/pt.png" alt="pt" /> &nbsp;Portugues</vs-dropdown-item>
                                      </vs-dropdown-menu>
                                    </vs-dropdown>
                                </div>
                                <div>
                                    <vs-input v-validate="'required|min:3'" data-vv-validate-on="blur" name="login" icon-no-border icon="icon icon-user"  icon-pack="feather" label="Login" @keyup.enter.native="efetuarLogin" v-model="login" class="w-full"/>
                                    <vs-input data-vv-validate-on="blur" v-validate="'required|min:4|max:10'" type="password" name="senha" icon-no-border icon="icon icon-lock" icon-pack="feather" label="Senha" v-model="senha" @keyup.enter.native="efetuarLogin" class="w-full mt-6" />                                       
                                    
                                    <div class="flex flex-wrap justify-between my-5">                    
                                          <vs-checkbox v-model="checkbox_remember_me" class="mb-3">{{ $t('TelaLogin_lLembrarSenha')}}</vs-checkbox>                                          
                                    </div>
                                    <div class="flex justify-between mb-3">
                                        <vs-button :disabled="!validateForm" @click="efetuarLogin" class="w-full mb-3">{{ $t('TelaLogin_lEntrar')}}</vs-button>
                                    </div>
                                    <div class="flex justify-between">
                                        <vs-button type="border" @click="routeTrocarSenha" class="mb-3">{{ $t('TelaLogin_lTrocarSenha')}}</vs-button>
                                        <vs-button type="border" @click="routeEsqueciMinhaSenha" class="ml-2 mb-3">{{ $t('TelaLogin_lEsqueciSenha')}}</vs-button>
                                    </div>
                                    <div class="flex justify-between mb-3" v-if="exibirLinkPoliticaPrivacidade">
                                      <a :href="getUrlPoliticaPrivacidade" target="_blank"> <p class="ml-auto text-xs font-medium"> {{ $t('PoliticaPrivacidade')}} </p> </a>
                                    </div>
                                </div>
                            </div>
                      </div>
                </div>
            </div>
        </vx-card>
    </div>
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 flex" v-if="isSigaFacil" :style="getBgColor">    
        <img :src="getLogoCentral" alt="login" class="mx-auto">                    
    </div>
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-2/5 sm:m-0 flex justify-center items-center" v-if="isSigaFacil" style="height: 100vh !important; background-color: #f8f8f8 !important">
      <div class="px-8 pt-8">
          <div class="vx-card__title mb-4">
              <p>Faça login em sua conta:</p>
          </div>
          
          <div>
              <vs-input v-validate="'required|min:3'" data-vv-validate-on="blur" name="login" icon-no-border icon="icon icon-user"  icon-pack="feather" label="Login" @keyup.enter.native="efetuarLogin" v-model="login" class="w-full"/>
              <vs-input data-vv-validate-on="blur" v-validate="'required|min:4|max:10'" type="password" name="senha" icon-no-border icon="icon icon-lock" icon-pack="feather" label="Senha" v-model="senha" @keyup.enter.native="efetuarLogin" class="w-full mt-6" />                                       
              
              <div class="flex flex-wrap justify-between my-5">                    
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Gravar login e senha nesse computador</vs-checkbox>                                          
              </div>
              <div class="flex justify-between mb-3">
                  <vs-button :disabled="!validateForm" @click="efetuarLogin" class="w-full mb-3" color="warning">ENTRAR</vs-button>
              </div>
              <div class="flex justify-between">
                  <vs-button type="border" @click="routeTrocarSenha" class="mb-3"  color="warning">{{ $t('TelaLogin_lTrocarSenha')}}</vs-button>
                  <vs-button type="border" @click="routeEsqueciMinhaSenha" class="ml-2 mb-3"  color="warning">{{ $t('TelaLogin_lEsqueciSenha')}}</vs-button>
              </div>
              <div class="flex justify-between mb-3" v-if="exibirLinkPoliticaPrivacidade">
                <a :href="getUrlPoliticaPrivacidade" target="_blank"> <p class="ml-auto text-xs font-medium"> {{ $t('PoliticaPrivacidade')}} </p> </a>
              </div>
               <div class="flex items-center" >                  
                  <p class="mr-auto text-xs font-medium">v. {{VERSAO}} </p>
              </div>      
          </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default { 
  props: {
    nomeCentral: {
      type: String      
    }
  }, 
  data() {
    return {
      login: '',
      senha: '',
      checkbox_remember_me: false,
      publicPath: process.env.BASE_URL,
      vNomeCentral: 'CONCEPT'
    }
  },
  created(){
      this.VERSAO = process.env.VUE_APP_NUMERO_VERSAO
  },
  mounted() {

    if (this.nomeCentral) {           
       this.$store.dispatch('updateNomeCentral', this.nomeCentral);   
       this.vNomeCentral = this.nomeCentral;
       localStorage.setItem('nomeCentral', this.nomeCentral);
    } else {
      var endereco = window.location.hostname;
      
      if (endereco == 'app.concept.inf.br') {
        this.$store.dispatch('updateNomeCentral', 'CONCEPT');   
      } else if (endereco == 'app.routetecnologia.com.br') {
        this.$store.dispatch('updateNomeCentral', 'ROUTESAT');   
      } else if (endereco == 'app.santrack.com.br') {
        this.$store.dispatch('updateNomeCentral', 'SANTRACK');   
      } else if (endereco == 'app.rastremais.com.br') {
        this.$store.dispatch('updateNomeCentral', 'RASTREMAIS');   
      } else if (endereco == 'app.takirastreadores.com.br') {
        this.$store.dispatch('updateNomeCentral', 'TAKI');   
      } else if (endereco == 'app.mastertrackrastreamentos.com.br') {
        this.$store.dispatch('updateNomeCentral', 'MASTERTRACK');   
      } else if (endereco == 'app.sigafacil.com.br') {
        this.$store.dispatch('updateNomeCentral', 'SIGAFACIL');   
      } else if (endereco == 'app.fortracks.com.br') {
        this.$store.dispatch('updateNomeCentral', 'FORTRACKS');   
      } else if (endereco == 'app.truetrack.com.br') {
        this.$store.dispatch('updateNomeCentral', 'TRUETRACK');   
      } else if (endereco == 'app.brastrack.com') {
        this.$store.dispatch('updateNomeCentral', 'BRASTRACK');   
      } else if (endereco == 'app.onsig.com.br') {
        this.$store.dispatch('updateNomeCentral', 'ONSIG');   
      }

      if (this.$store.state.nomeCentral) {
         this.vNomeCentral = this.$store.state.nomeCentral;                  
         if (!localStorage.getItem('nomeCentral') || localStorage.getItem('nomeCentral') === 'undefined') {
           localStorage.nomeCentral = this.$store.state.nomeCentral;
         }
      } else {
        if (localStorage.getItem('nomeCentral') && localStorage.getItem('nomeCentral') !== 'undefined') {          
          this.vNomeCentral = localStorage.nomeCentral;     
        } else {          
          localStorage.setItem('nomeCentral', this.vNomeCentral);
        }
      }
    }
    
    this.checkbox_remember_me =  false;
    if (localStorage.getItem('login')) {
      this.login = localStorage.getItem('login');
      this.checkbox_remember_me =  true;
    }
    if (localStorage.getItem('senha')) {
      this.senha = localStorage.getItem('senha');
    }

    if (localStorage.getItem('locale')) {
       this.updateLocale(localStorage.getItem('locale'));
    }        
    this.$store.dispatch("limparDadosSessao");

    if (!this.$route.meta.hasOwnProperty('origem') || this.$route.meta.origem !== 'click-menu-sair') {
      if (this.validateForm) {
        this.efetuarLogin();
      }
    }
  },
  computed: {
    isSigaFacil() {
        if (this.vNomeCentral && this.vNomeCentral === 'sigafacil') {
          return true;
        }

        return false;
    },
    getBgColor() {
      
        if (this.isSigaFacil) {
            return "background-color:#f2725c";
        } else if (this.vNomeCentral.toUpperCase() === 'TAKI') {
            return "background-color: #ffffff";
        } else {
            return "background-color:#252e3a";
        }
    },
    isAcessoIndividual(){
        return this.$store.getters.isAcessoIndividual;
    },
    isAcessoGrupo(){
        return this.$store.getters.isAcessoGrupo;
    },
    getLogoCentral() {
      return this.publicPath + "imagens/logoCENTRAIS/logo" + this.vNomeCentral.toUpperCase() +".png";
    },
    validateForm() {
      return this.login != '' && this.senha != '';
    },
    i18n_locale_img() {
      return require(`@/assets/images/flags/${this.$i18n.locale}.png`)
    },
    getCurrentLocaleData() {
        const locale = this.$i18n.locale;

        if (!locale) {
          return { flag: "br", lang: 'Português' };
        }

        if (locale == "en")      return { flag: "us", lang: 'English'   }
        else if (locale == "pt") return { flag: "br", lang: 'Português' }
        else if (locale == "es") return { flag: "es", lang: 'Español'   }        
    },
    exibirLinkPoliticaPrivacidade() {
      return this.vNomeCentral === 'CONCEPT';
    },
    getUrlPoliticaPrivacidade(){
      return "https://s3.amazonaws.com/concept.inf.br/policy/PoliticaPrivacidade-v23102020.pdf";
    }
  },
  methods: {
    routeTrocarSenha() {  
      this.$router.push({ path: '/alterar-senha' })    
    },
    routeEsqueciMinhaSenha() {  
      this.$router.push({ path: '/esqueci-minha-senha' })    
    },
    updateLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('locale', locale);
    },  
    getPathAfterLoginPro(){    
      
        if (this.isAcessoGrupo && this.$store.state.AppActiveUser.permissoes.menuDashboard_Veiculos) {
            return '/dashboard/veiculos';
        }

        if (this.isAcessoGrupo && this.$store.state.AppActiveUser.permissoes.menuGrid) {
            return '/grid';
        }

        if (this.isAcessoGrupo && this.$store.state.AppActiveUser.permissoes.menuMapa) {
            return '/mapa';
        }

        if (this.isAcessoGrupo && this.$store.state.AppActiveUser.visualizaPercurso) {
            return '/percursos';
        }

        if (this.isAcessoGrupo) {
            return '/blank';
        }

        return '/dashboard/veiculos';
      
    }, 
    getPathAfterLoginBasic(){       
        if (this.isAcessoGrupo && this.$store.state.AppActiveUser.permissoes.menuGrid) {
            return '/grid';
        }

        if (this.isAcessoGrupo && this.$store.state.AppActiveUser.permissoes.menuMapa) {
            return '/mapa';
        }

        if (this.isAcessoGrupo && this.$store.state.AppActiveUser.visualizaPercurso) {
            return '/percursos';
        }

        return '/mapa';      
    }, 
    efetuarLogin() {      
      const params = new URLSearchParams();
      params.append('login', this.login);
      params.append('senha', this.senha);
      params.append('outputFormat', 'JSON');
      
      this.$vs.loading();

      let currentObj = this;
      
      this.$http.post(
        '/ValidarLoginSenhaCliente', 
        params, 
        { headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'}
      })
      .then(function (response) {
          currentObj.$vs.loading.close();

          if (currentObj.checkbox_remember_me ) {
            localStorage.setItem('login', currentObj.login);
            localStorage.setItem('senha',currentObj.senha);
          } else {
            localStorage.removeItem('login');
            localStorage.removeItem('senha');
          } 
          
          if (response.data.id > 0) {     
              if (response.data.status == "ATIVO") {                          
                  currentObj.$store.commit("SALVAR_DADOS_PARA_RELOGIN", {relogin: currentObj.login, resenha: currentObj.senha });   
                  currentObj.$store.commit("SALVAR_USUARIO_LOGADO", response.data);   
                  currentObj.$store.dispatch('updateNomeCentral', currentObj.nomeCentral);
                  if (currentObj.isAcessoIndividual) {
                      currentObj.$router.push({ path: '/mapa' })
                  } else {
                      currentObj.$store.dispatch("setExibirMensagemVeiculoDesatualizado");
                      
                      if (response.data.versaoProduto === 'FAST') {
                          currentObj.$router.push({ path: '/fast' })
                      } else if (response.data.versaoProduto === 'BASIC') {
                          if (response.data.exibirTelaConfirmacaoDadosVeiculos) {
                              currentObj.$router.push({ path: '/configuracao/veiculo/alterar-dados-contato' })
                          } else {
                            currentObj.$router.push({ path: currentObj.getPathAfterLoginBasic() })
                          }
                      } else {
                          if (response.data.exibirTelaConfirmacaoDadosVeiculos) {
                              currentObj.$router.push({ path: '/configuracao/veiculo/alterar-dados-contato' })
                          } else {
                            currentObj.$router.push({ path: currentObj.getPathAfterLoginPro() })
                          }
                      }
                  }
              } else {                	
                  currentObj.$vs.notify({
                    title: currentObj.$t('Erro'),
                    text: currentObj.$t('Mensagem_Login_Bloqueado', {nomeCentral:response.data.nomeCentral, telefoneCentral:response.data.telefoneCentral }),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  });  
              }
          } else if (response.data.id === -1) {     
            currentObj.$vs.notify({
                title: currentObj.$t('Erro'),
                text: response.data.mensagem,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
          } else {
              currentObj.$vs.notify({
                title: currentObj.$t('Erro'),
                text: currentObj.$t('Mensagem_LoginInvalido'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
          }
      })
      .catch(function (error) {
          currentObj.$vs.loading.close();
          
          currentObj.$vs.notify({
            title: currentObj.$t('Erro'),
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
      });

    },
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 455px;

  .con-tab {
    padding-bottom: 10px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
